import { MeasurementCapability, RawMeasurementCapability } from "@/types/measurementCapability";

export const mapRawMeasurementCapabilities = (
  raw: RawMeasurementCapability,
): MeasurementCapability => {
  return {
    id: raw.id,
    recipes: raw.recipes.map((r) => r.id),
    name: raw.name,
  };
};
